export const API_ERROR_RETRY_COUNT = 30
export const API_ERROR_RETRY_DELAY = 6000
